{
	"ariaToggleHighlightsClipping": "Toggle Histogram Highlights Clipping Warning",
	"ariaToggleShadowsClipping": "Toggle Histogram Shadows Clipping Warning",
	"tooltipHideHighlightsClipping": "Hide Highlights Clipping (J)",
	"tooltipHideShadowsClipping": "Hide Shadows Clipping (J)",
	"tooltipShowHighlightsClipping": "Show Highlights Clipping (J)",
	"tooltipShowShadowsClipping": "Show Shadows Clipping (J)"
}
